
/**
 * Utilities for storing strategy data temporarily in session storage
 * to maintain state across authentication redirects
 */

// Key for storing strategy in session storage
const STRATEGY_STORAGE_KEY = 'metrade_temp_strategy';
const REDIRECT_URL_KEY = 'metrade_redirect_url';

/**
 * Store strategy data in session storage for retrieval after authentication
 */
export const storeStrategyForRedirect = (strategy: any) => {
  try {
    sessionStorage.setItem(STRATEGY_STORAGE_KEY, JSON.stringify(strategy));
  } catch (err) {
    console.error('Failed to store strategy in session storage:', err);
  }
};

/**
 * Get stored strategy data from session storage
 */
export const getStoredStrategy = () => {
  try {
    const strategyData = sessionStorage.getItem(STRATEGY_STORAGE_KEY);
    if (!strategyData) return null;
    
    return JSON.parse(strategyData);
  } catch (err) {
    console.error('Failed to retrieve strategy from session storage:', err);
    return null;
  }
};

/**
 * Clear stored strategy data from session storage
 */
export const clearStoredStrategy = () => {
  try {
    sessionStorage.removeItem(STRATEGY_STORAGE_KEY);
  } catch (err) {
    console.error('Failed to clear strategy from session storage:', err);
  }
};

/**
 * Store redirect URL for after authentication
 */
export const storeRedirectUrl = (url: string) => {
  try {
    sessionStorage.setItem(REDIRECT_URL_KEY, url);
  } catch (err) {
    console.error('Failed to store redirect URL in session storage:', err);
  }
};

/**
 * Get stored redirect URL from session storage
 */
export const getRedirectUrl = () => {
  try {
    return sessionStorage.getItem(REDIRECT_URL_KEY);
  } catch (err) {
    console.error('Failed to retrieve redirect URL from session storage:', err);
    return null;
  }
};

/**
 * Clear stored redirect URL from session storage
 */
export const clearRedirectUrl = () => {
  try {
    sessionStorage.removeItem(REDIRECT_URL_KEY);
  } catch (err) {
    console.error('Failed to clear redirect URL from session storage:', err);
  }
};
